import { ListSuperAdminAuditLogsResponseSchema } from './list-superadmin-audit-logs.schema';
export const listSuperAdminAuditLogsContract = {
    method: 'GET',
    path: '/api/v2/superadmin-audit-logs',
    description: 'Query audit logs with optional tenant scoping (super-admin only)',
    responseSchema: ListSuperAdminAuditLogsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=list-superadmin-audit-logs.contract.js.map